import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, BoxModelConstraint, BusinessComponent, BusinessComponentOptions } from '@blk/simba';
import { ComponentData, TabUtil } from '@ddt-web/data-service';

import { DisclosureComponent } from '../disclaimers/disclosure-component';

/**
 * A simple repeatable Business Component that contains a disclosure.
 */
export class SectionDisclaimerComponent extends BusinessComponent {
	constructor(
		public disclaimerDcrKey: string,
		public disclaimerDefaultText: string,
		public options: BusinessComponentOptions,
		public showIfNoDataAvailable: boolean = false,
		public disclaimerTextClasses?: string[],
		public constraints: Partial<BoxModelConstraint> = { paddingTop: 0, paddingBottom: 8 }
	) {
		super(disclaimerDcrKey, 'BusinessComponent', BusinessComponentOptions.merge(options));
	}

	public isComponentDataVisible(componentData: ComponentData): boolean {
		return Boolean(componentData && componentData.success && componentData.tabs && componentData.tabs.length);
	}

	/**
	 * Builds the component for the panel.
	 * If there is no data available for that componentData, an empty array is returned.
	 */
	public buildComponent(componentData: ComponentData, contentSvc: ContentService): AbstractRenderer<SVGGElement>[] {
		if (this.isComponentDataVisible(componentData) && !TabUtil.areRawValuesNotAvailable(componentData)) {
			return [new DisclosureComponent(this.disclaimerDcrKey, this.disclaimerDefaultText, {}, this.constraints, this.disclaimerTextClasses)];
		}
		return [];
	}
}
